import styled from '@emotion/styled'

export const Small = styled.small(({ theme }) => ({
  fontSize: theme.fontSizeSm,
  color: theme.textColorLight,
}))
